import React from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import './PolicyPage.css';

const TermsOfService = () => {
  return (
    <Layout>
      <PageMeta
        title="Terms of Service"
        description="Fmultratech Farms Terms of Service. Terms and conditions for using our platform and services."
      />
      <div className="policy-page">
        <div className="policy-hero">
          <h1>Terms of Service</h1>
          <p>FMultratech Farms</p>
        </div>
        <div className="policy-content">
          <div className="policy-container">
            <section className="policy-section">
              <h2>1. Introduction</h2>
              <p>
                These Terms of Service (“Terms”) govern your access to and use of the FMultratech Farms platform, including our website, mobile application, and related services (“Services”). By accessing or using our Services, you agree to be legally bound by these Terms.
              </p>
              <p>
                If you do not agree with these Terms, you must discontinue use of the Services immediately.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Definitions</h2>
              <p>
                <strong>“Company”, “we”, “us”, or “our”</strong> refers to FMultratech Farms.
              </p>
              <p>
                <strong>“User”, “Customer”, or “you”</strong> refers to any individual or entity accessing or using the Services.
              </p>
              <p>
                <strong>“Platform”</strong> refers to the FMultratech Farms website, application, or any digital interface operated by the Company.
              </p>
            </section>

            <section className="policy-section">
              <h2>3. Eligibility</h2>
              <p>
                By using our Services, you represent and warrant that:
              </p>
              <ul>
                <li>You are legally capable of entering into a binding agreement;</li>
                <li>All information provided by you is accurate and current;</li>
                <li>You will use the Services in compliance with applicable laws and regulations.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Account Registration</h2>
              <h3>4.1</h3>
              <p>
                Certain features may require account creation.
              </p>
              <h3>4.2</h3>
              <p>
                Users are responsible for:
              </p>
              <ul>
                <li>Maintaining the confidentiality of login credentials;</li>
                <li>All activities conducted under their account.</li>
              </ul>
              <h3>4.3</h3>
              <p>
                The Company reserves the right to suspend or terminate accounts that violate these Terms.
              </p>
            </section>

            <section className="policy-section">
              <h2>5. Orders and Production Process</h2>
              <h3>5.1</h3>
              <p>
                Orders placed through the Platform may be submitted to production or fulfillment partners.
              </p>
              <h3>5.2</h3>
              <p>
                Once an order has been submitted for production, it may no longer be eligible for cancellation or refund except as outlined in the Return and Refund Policy.
              </p>
              <h3>5.3</h3>
              <p>
                The Company reserves the right to refuse or cancel orders in cases including but not limited to:
              </p>
              <ul>
                <li>Suspected fraud;</li>
                <li>Pricing or system errors;</li>
                <li>Operational limitations.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>6. Payments</h2>
              <h3>6.1</h3>
              <p>
                Users agree to pay all applicable charges associated with orders placed through the Platform.
              </p>
              <h3>6.2</h3>
              <p>
                Payment processing may be handled by third-party providers. The Company is not responsible for errors caused by payment processors.
              </p>
              <h3>6.3</h3>
              <p>
                Refund eligibility is governed by the Company’s Return and Refund Policy.
              </p>
            </section>

            <section className="policy-section">
              <h2>7. User Conduct</h2>
              <p>
                Users agree not to:
              </p>
              <ul>
                <li>Use the Platform for unlawful purposes;</li>
                <li>Attempt unauthorized access to systems or accounts;</li>
                <li>Interfere with platform functionality or security;</li>
                <li>Provide false or misleading information.</li>
              </ul>
              <p>
                Violation may result in suspension or termination of access.
              </p>
            </section>

            <section className="policy-section">
              <h2>8. Intellectual Property</h2>
              <p>
                All content, trademarks, logos, designs, and materials on the Platform are owned by or licensed to FMultratech Farms and are protected by applicable intellectual property laws.
              </p>
              <p>
                Users may not copy, reproduce, distribute, or exploit any content without prior written permission.
              </p>
            </section>

            <section className="policy-section">
              <h2>9. Privacy</h2>
              <p>
                Use of the Services is also governed by our Privacy Policy, which describes how we collect, use, and protect user data.
              </p>
            </section>

            <section className="policy-section">
              <h2>10. Service Availability</h2>
              <p>
                We aim to provide reliable service but do not guarantee uninterrupted or error-free operation. The Company reserves the right to modify, suspend, or discontinue any part of the Services at any time.
              </p>
            </section>

            <section className="policy-section">
              <h2>11. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law:
              </p>
              <ul>
                <li>FMultratech Farms shall not be liable for indirect, incidental, or consequential damages arising from use of the Platform.</li>
                <li>The Company’s total liability shall not exceed the amount paid by the User for the specific transaction giving rise to the claim.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>12. Indemnification</h2>
              <p>
                Users agree to indemnify and hold harmless FMultratech Farms from claims, losses, liabilities, damages, or expenses arising from:
              </p>
              <ul>
                <li>Violation of these Terms;</li>
                <li>Misuse of the Platform;</li>
                <li>Breach of applicable laws.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>13. Termination</h2>
              <p>
                The Company may suspend or terminate access to the Services at any time if a User violates these Terms or engages in activities that may harm the Platform or other users.
              </p>
            </section>

            <section className="policy-section">
              <h2>14. Changes to Terms</h2>
              <p>
                FMultratech Farms reserves the right to update or modify these Terms at any time. Continued use of the Services after updates constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section className="policy-section">
              <h2>15. Governing Law</h2>
              <p>
                These Terms shall be governed by and interpreted in accordance with the applicable laws of the Federal Republic of Nigeria.
              </p>
            </section>

            <section className="policy-section">
              <h2>16. Contact Information</h2>
              <p>
                For inquiries regarding these Terms, please contact us through the official communication channels provided on the FMultratech Farms platform.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfService;
